import { getMappedRoleByPermissionId } from '../permissionMapper';

interface PermissionConfigLike {
  perm_id: number;
}

interface UserPermissionLike {
  perm_id: number;
}

interface ResolveOptions<TConfig extends PermissionConfigLike> {
  permissionsConfig: TConfig[];
  userPermissions: UserPermissionLike[];
  jwtPermId?: number | null;
  savedPermId?: number | null;
  onLog?: (message: string, data?: Record<string, unknown>) => void;
}

function isSelectablePermissionId<TConfig extends PermissionConfigLike>(
  permId: number,
  permissionsConfig: TConfig[],
): boolean {
  return permissionsConfig.some(
    (config) => config.perm_id === permId && getMappedRoleByPermissionId(config.perm_id) !== null,
  );
}

function logResolution(
  onLog: ResolveOptions<PermissionConfigLike>['onLog'],
  message: string,
  permId: number,
): void {
  onLog?.(message, { permId });
}

export function resolveInitialActivePermission<TConfig extends PermissionConfigLike>({
  permissionsConfig,
  userPermissions,
  jwtPermId,
  savedPermId,
  onLog,
}: ResolveOptions<TConfig>): number | null {
  if (savedPermId !== null && savedPermId !== undefined) {
    if (isSelectablePermissionId(savedPermId, permissionsConfig)) {
      logResolution(onLog, '✅ [PERMISSION] Usando preferência salva', savedPermId);
      return savedPermId;
    }
  }

  if (jwtPermId !== null && jwtPermId !== undefined) {
    if (isSelectablePermissionId(jwtPermId, permissionsConfig)) {
      logResolution(onLog, '✅ [PERMISSION] Usando perm_id do JWT', jwtPermId);
      return jwtPermId;
    }
  }

  for (const permission of userPermissions) {
    if (isSelectablePermissionId(permission.perm_id, permissionsConfig)) {
      logResolution(onLog, '✅ [PERMISSION] Usando permissão suportada do usuário', permission.perm_id);
      return permission.perm_id;
    }
  }

  for (const config of permissionsConfig) {
    if (getMappedRoleByPermissionId(config.perm_id) !== null) {
      logResolution(onLog, '✅ [PERMISSION] Usando primeiro config suportado disponível', config.perm_id);
      return config.perm_id;
    }
  }

  return null;
}
